import * as yup from 'yup';

import {MessageId} from './messages';
import type {PasswordValidationRules} from './types';

const passwordSymbolsRegex = new RegExp(/^[A-Za-z0-9!"\\#$%&'()*+,-./:;<=>?@[\]^_`|~]+$/);

export const testPasswordComplexity = (password: string, validationsRules: PasswordValidationRules) => {
    if (validationsRules.PasswordRequireLowercase && !(new RegExp(/[a-z]/).test(password))) {
        return false;
    }
    if (validationsRules.PasswordRequireNumber && !(new RegExp(/[0-9]/).test(password))) {
        return false;
    }
    if (validationsRules.PasswordRequireSymbol && !(new RegExp(/[!"\\#$%&'()*+,-./:;<=>?@[\]^_`|~]/).test(password))) {
        return false;
    }
    if (validationsRules.PasswordRequireUppercase && !(new RegExp(/[A-Z]/).test(password))) {
        return false;
    }

    return true;
};

export const getTestPasswordComplexity = (validationsRules: PasswordValidationRules) => {
    return (password = '') => testPasswordComplexity(password, validationsRules);
};

export const getNewPasswordValidationSchema = (validationsRules: PasswordValidationRules) =>
    yup.object().shape({
        password: yup.
            string().
            required(MessageId.Required).
            min(validationsRules.PasswordMinimumLength, MessageId.TooShort).
            max(validationsRules.PasswordMaximumLength, MessageId.TooLong).
            matches(passwordSymbolsRegex, MessageId.Symbols).
            test(
                MessageId.TooWeak,
                MessageId.TooWeak,
                getTestPasswordComplexity(validationsRules),
            ),
        repeat_password: yup.string().oneOf([yup.ref('password')], MessageId.NoMatch).required(),
    });
